const CATEGORY_NAME_TOKEN_PATTERN = /[^a-zA-Z0-9]+/

const splitCategoryNameTokens = (apiName: string): string[] =>
  apiName.trim().split(CATEGORY_NAME_TOKEN_PATTERN).filter(Boolean)

const hasNonAlphanumeric = (value: string): boolean => CATEGORY_NAME_TOKEN_PATTERN.test(value)

export const toCategoryKey = (apiName: string): string => {
  const tokens = splitCategoryNameTokens(apiName)

  if (!tokens.length) {
    return ''
  }

  return tokens
    .map((token, index) => {
      const normalizedToken = token.toLowerCase()

      if (index === 0) {
        return normalizedToken
      }

      return normalizedToken.charAt(0).toUpperCase() + normalizedToken.slice(1)
    })
    .join('')
}

export const adaptCategoryNameFromApi = (apiCategoryName: string): string =>
  toCategoryKey(apiCategoryName)

export const toFilterCategoryKey = (value: string): string => {
  if (!value || value.toLowerCase() === 'all') {
    return 'all'
  }

  if (value === 'favorite') {
    return 'favorite'
  }

  return hasNonAlphanumeric(value) ? adaptCategoryNameFromApi(value) : value
}
